import { css } from "@emotion/react"
import { CleaningPlace } from "./CleaningPlace"
import { ApprovalRequest, calcTotalUnitPrice } from "@/model/approvalRequest"

export const CleaningPlaceList = ({
    reportedApprovalRequests
}: {
    reportedApprovalRequests: ApprovalRequest[]
}) => {
    return (
        <div
            css={css`
                display: grid;
                grid-template-columns: auto 1fr;
                gap: 8px;
                align-items: center;
            `}
        >
            {reportedApprovalRequests.map(approvalRequest => (
                <CleaningPlace
                    key={approvalRequest.id}
                    cleaningId={approvalRequest.cleaningId}
                    cleaningPrice={calcTotalUnitPrice(approvalRequest)}
                />
            ))}
        </div>
    )
}
